export default __webpack_public_path__ + "static/media/0.6e58634a.jpg";